import { fieldParsers } from './fieldParsers';

const { toBoolean } = fieldParsers;

export const pushSelectedFlagInArray = (allFields: any, futherNeeds: any[], flagName: string) => {
  if (toBoolean(allFields[flagName])) {
    futherNeeds.push(flagName);
  }
};
